import {
  GET_PETITIONS_REQUEST,
  GET_PETITIONS_SUCCESS,
  GET_PETITIONS_FAILED,
  SET_DASHBOARD_VIEW_BY,
  GET_DASHBOARD_TEAMS_SUCCESS,
  GET_DASHBOARD_TEAMS_FAILED,
} from './actionTypes';
import { viewByOptions } from './constants';

const initialState = {
  data: [],
  page: 1,
  lastPage: 1,
  loading: false,
  error: null,
  search: '',
  sort: null,
  order: null,
  perPage: 10,
  viewBy: viewByOptions[0].value,
  teams: [],
};

const dashboardPetitions = (state = initialState, {
  type, error, data, teams, meta, viewBy,
}) => {
  switch (type) {
    case GET_PETITIONS_REQUEST:
      return { ...state, loading: true };
    case GET_PETITIONS_SUCCESS:
      return {
        ...state,
        data,
        search: meta.search,
        page: meta.current_page,
        lastPage: meta.last_page,
        perPage: meta.per_page,
        order: meta.order,
        sort: meta.sort,
        loading: false,
      };
    case GET_PETITIONS_FAILED:
      return { ...state, loading: false, error };
    case GET_DASHBOARD_TEAMS_SUCCESS:
      return {
        ...state,
        teams,
      };
    case GET_DASHBOARD_TEAMS_FAILED:
      return { ...state, loading: false, error };
    case SET_DASHBOARD_VIEW_BY:
      return { ...state, viewBy };
    default:
      return state;
  }
};

export default dashboardPetitions;
